import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineMagnifyingGlass } from "react-icons/hi2";

import useDebounceQuery from "@/hooks/useDebounceQuery";
import Input, { InputHTMLProps } from "@/components/atoms/input/Input";
import InputLabel from "@/components/atoms/input/InputLabel";

type SearchInputProps = {
  label?: string;
  onQueryUpdate?: (query: string) => void;
  onTyping?: (isTyping: boolean) => void;
} & Omit<InputHTMLProps, "leftPlaceholder" | "tooltip">;

const SearchInput = ({
  hasError,
  placeholder,
  disabled,
  onQueryUpdate,
  className,
  label,
  onTyping,
}: SearchInputProps) => {
  const { t } = useTranslation();
  const { query, setDebounceQuery, isTyping } = useDebounceQuery();

  useEffect(() => {
    onQueryUpdate?.(query);
  }, [query, onQueryUpdate]);

  useEffect(() => {
    onTyping?.(isTyping);
  }, [isTyping, onTyping]);

  return (
    <div className={className}>
      {label && <InputLabel label={label} className={"mb-1.5"} />}
      <Input
        hasError={hasError}
        leftPlaceholder={<HiOutlineMagnifyingGlass className={"size-5"} />}
        onChange={(e) => setDebounceQuery(e.target.value)}
        placeholder={placeholder || t("search.search")}
        disabled={disabled}
      />
    </div>
  );
};

export default SearchInput;
